import axios from "axios";

export const update = (requestParams, formData, callback) => {
  const promise = axios({
    method: 'patch',
    url: Routes.public_crm_tutorial_tour_capsule_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}
